import { atom, selector } from 'recoil'
import { editorState } from './editor'

export const modalBeeSavedRowMetadataState = atom({
  key: 'modalBeeSavedRowTemplateMetadataState',
  default: {
    show: false,
    onConfirm: undefined,
    onCancel: undefined,
    resolveMetadata: false,
    row: undefined,
    metadata: {
      name: undefined
    },
    mode: ''
  }
})

export const backUrlState = selector({
  key: 'modalBeeSavedRowTemplatebackUrlState',
  get: ({ get }) => {
    const { templateDetails, kind, mode } = get(editorState)

    const ret = `/templates/${kind}/${mode}/${templateDetails.id}`
    return ret
  }
})
